import gql from 'graphql-tag';
export const TASKS_QUERY = gql`
  query getTasks(
    $lookAfter: [Any]
    $lookBefore: [Any]
    $limit: Int
    $fullText: String
    $sortFilter: [SortSpec]
    $filters: TaskDataFilter
  ) {
    tasks: tasksCollection(
      lookAfter: $lookAfter
      lookBefore: $lookBefore
      limit: $limit
      sort: $sortFilter
      fullText: $fullText
      filter: $filters
    ) {
      totalCount
      nextLookAfterKey
      previousLookBeforeKey
      items {
        id
        version
        name
        contactName
        ref
        providerId
        policyNumber
        riskCode
        partyCode
        email
        tel
        notify
        companyId
        userId
        createdDate
        assignedDate
        completedDate
        resolution
        status
        type
        contract
        service
        contractReference {
          snn
          ref
          version
          created_ts
          started_ts
          finished_ts
          closed_ts
          state
          type
          provider
          lastCompany
          name
          policyNumber
          riskCode
          partyCode
          phoneNumber
          emailAddress
          notes {
            snn
            created_ts
            deleted_ts
            creator
            text
            service
          }
        }
        cancellationReason
        claimed
        techValidator
        techValidation_ts
        claimValidator
        claimValidation_ts
        deviceType
        address {
          streetAddress
          latitude
          longitude
        }
        notes {
          timestamp
          note
        }
        install {
          oldSerial
          newSerial
          serial
          images {
            src
            tag
            comment
            label
          }
          questionsAnswers {
            question
            answer
          }
        }
        questionnaire {
          default
          label
          tag
          type
          child
          options {
            title
            value
          }
        }
        requiredImages {
          comment
          label
          tag
          src
        }
        companyReference {
          snn
          name
          tags
          created_ts
          meta
        }
        providerReference {
          snn
          name
          tags
          created_ts
          meta
        }
      }
    }
  }
`;

export const TASK_QUERY = gql`
  query getTasksy($id: String!) {
    task(id: $id) {
      id
      version
      name
      contactName
      ref
      providerId
      policyNumber
      riskCode
      partyCode
      email
      tel
      notify
      companyId
      userId
      createdDate
      assignedDate
      completedDate
      resolution
      status
      type
      contract
      service
      contractReference {
        snn
        ref
        version
        created_ts
        started_ts
        finished_ts
        closed_ts
        state
        type
        provider
        lastCompany
        name
        policyNumber
        riskCode
        partyCode
        phoneNumber
        emailAddress
        notes {
          snn
          created_ts
          deleted_ts
          creator
          text
          service
        }
      }
      cancellationReason
      claimed
      techValidator
      techValidation_ts
      claimValidator
      claimValidation_ts
      deviceType
      address {
        building
        geometry {
          location {
            lat
            lng
          }
        }
      }
      notes {
        timestamp
        note
      }
      install {
        tags
        geyserId
        oldSerial
        newSerial
        serial
        simimsi
        images
        customerFeedback
        questionsAnswers {
          question
          answer
        }
      }
      questionnaire {
        label
        tag
        type
        default
      }
      companyReference {
        snn
        name
        tags
        created_ts
        meta
      }
      providerReference {
        snn
        name
        tags
        created_ts
        meta
      }
    }
  }
`;
export interface AddressLocation {
  latitude: number;
  longitude: number;
  point?: any[];
  building?: string;
  streetAddress?: string;
  locality?: string;
  municipality?: string;
  province?: string;
  state?: string;
  country?: string;
}



// WEBPACK FOOTER //
// ./src/providers/tasks/queries.ts